import { CollapsableTable, DataRowsFromPLA, DataRow } from "components/CollapsableTable";
import { SelectFormatter }       from "functions/Formatting";
import { fieldNames, units }     from "functions/GeneralTranslations";
import { Glob, useLoc }          from "functions/Language";
import { TYPE_PLA, TYPE_GCR, IsFromDevice, RType, SupportedDevices, TYPE_GCRT, TYPE_ICR } from "functions/networking/NetTypes";
import { FC } from "react";


export const MeasurementsTable: FC<{
	data: RType<"Online" | "Online_Short", SupportedDevices>
}> = (props) => {
	const loc = useLoc(glob);
	const fields = useLoc(fieldNames);

	let llRows = undefined;
	let lnRows = undefined;

	if (IsFromDevice(props.data, TYPE_PLA)) {
		llRows = DataRowsFromPLA(
			fields, units,
			[
				{ label: "U_LL", 3: "U_LL" },
			],
			props.data.Data
		);
		lnRows = DataRowsFromPLA(
			fields, units,
			[
				/* 0 */ { label: "U_LN", 3: "U_LN" },
				/* 1 */ { label: "Current", 3: "Current", 1: "Current_Zero" },
				/* 2 */ { label: "CosFi_Mod", 3: "CosFi_Mod", 1: "CosFi_3F_Mod" },
				/* 3 */ { label: "P", 3: "P", 1: "P_3F" },
				/* 4 */ { label: "Q", 3: "Q", 1: "Q_3F" },
				/* 5 */ { label: "S", 3: "S", 1: "S_3F" },
				/* 6 */ { label: "Frequency", 1: "Frequency" },
			],
			props.data.Data
		);
	}
	else if (IsFromDevice(props.data, [TYPE_GCR, TYPE_GCRT])) {
		lnRows = ([
			"U_LL", "Current", "CosFi_Mod", "P", "Q", "S", "Frequency"
		] as const satisfies readonly (keyof typeof props.data.Data)[]).map(k => ({
			values: props.data.Data[k], formatter: SelectFormatter(k, props.data.Head._type), label: fields[k], unit: units[k]
		} as DataRow));
	}
	else if (IsFromDevice(props.data, TYPE_ICR)) {
		lnRows = ([
			"CosFi_Mod", "P", "Q", "S",
		] as const satisfies readonly (keyof typeof props.data.Data)[]).map(k => ({
			values: props.data.Data[k], formatter: SelectFormatter(k, props.data.Head._type), label: fields[k], unit: units[k]
		} as DataRow));
	}

	return <div style={{padding: ".5%", flex: "1"}} className="table">
		{llRows && <CollapsableTable LL title={loc.name} nopad data={llRows} />}
		{lnRows && <CollapsableTable    title={loc.name} nopad data={lnRows} />}
	</div>
}


const glob = Glob({
	en: {
		name: "Quantity",
		value: "Value",
	},
	cs: {
		name: "Veličina",
		value: "Hodnota",
	},
	pg: {
		name: "Quantidade",
		value: "Valor",
	},
	es: {
		name: "Cantidad",
		value: "Valor",
	},
} as const);

